import type { InventoryItemSummaryCounts } from '@/renderer/types/inventory';
import React from 'react';

function SummaryCard({ label, value }: { label: string; value: number }) {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
      <p className="text-sm font-medium text-gray-600">{label}</p>
      <p className="mt-2 text-3xl font-semibold text-gray-900">{value}</p>
    </div>
  );
}

export function InventoryItemsSummaryCards({
  summary,
}: {
  summary: InventoryItemSummaryCounts;
}) {
  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      <SummaryCard label="Inventory items" value={summary.totalItems} />
      <SummaryCard label="Active items" value={summary.activeItems} />
      <SummaryCard label="Inactive items" value={summary.inactiveItems} />
      <SummaryCard label="Categories" value={summary.categoryCount} />
    </div>
  );
}
